export default {
  en: {
    transfer: 'Transfer',
    keyword: 'Keyword',
    default: 'Default',
    name: 'Name',
    price: 'Price',
    unit: 'Unit',
    pax: 'Pax',
    status: 'Status',
    conditionDetail: 'Condition',
    transferUnitTypeCar: '/ Car',
    transferUnitTypePerPerson: '/ Person',
    newTransfer: 'New Transfer',
    confirmRemoveTransferTitle: 'Confirm',
    confirmRemoveTransferMessage: 'Confirm to Delete <strong>{transferName}</strong>?',
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel',
    removeTransferSuccess: 'Remove transfer success',
    updateIsDefaultTransferSuccess: 'Update default transfer success'
  },
  th: {
    transfer: 'รถรับส่ง',
    keyword: 'คำที่ต้องการค้นหา',
    default: 'ค่าเริ่มต้น',
    name: 'ชื่อ',
    price: 'ราคา',
    unit: 'หน่วย',
    pax: 'จำนวน',
    status: 'สถานะ',
    conditionDetail: 'เงื่อนไขและรายละเอียด',
    transferUnitTypeCar: '/ คัน',
    transferUnitTypePerPerson: '/ คน',
    newTransfer: 'สร้างรถรับส่ง',
    confirmRemoveTransferTitle: 'ยืนยัน',
    confirmRemoveTransferMessage: 'กรุณายืนยันการลบ <strong>{transferName}</strong>',
    confirmButtonText: 'ยืนยัน',
    cancelButtonText: 'ยกเลิก',
    removeTransferSuccess: 'ลบรถรับส่งสำเร็จ',
    updateIsDefaultTransferSuccess: 'แก้ไขการตั้งค่าเริ่มต้นสำเร็จ'
  }
}
